import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { StructureModule } from './structure/structure.module';
import { SharedModule } from './shared/shared.module';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Angulartics2Module } from 'angulartics2';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    StructureModule,
    SharedModule.forRoot(),
    GraphQLModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    NgxPermissionsModule.forRoot(),
    Angulartics2Module.forRoot({
      pageTracking: {
        clearIds: true,
        clearQueryParams: true
      },
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
